import React from 'react'
import photo from '../../assets/Z2.jpg'

const SocialButton = (props) =>{
  return(
    <a target="_blank" rel="noreferrer" className={`text-xs xl:text-3xl 2xl:text-4xl text-white px-2 xl:px-4 2xl:px-6 py-1 xl:py-3 2xl:py-4 mt-2 xl:mt-8 2xl:mt-10 rounded-xl xl:rounded-2xl 2xl:rounded-3xl ${props.color}`} href={props.link}>
      {props.name}
    </a>
  )
}

export const Hero = () => {
  return (
    <div id="hero" className='flex pt-16 xl:pt-24 2xl:pt-28 pb-4 2xl:pb-8 px-6 xl:px-20 2xl:px-40 bg-stone-100 dark:bg-stone-600 dark:text-white'>
        
        <div className='flex flex-col justify-center w-1/2 pr-2'> 
            <div className='font-extrabold text-lg xl:text-6xl 2xl:text-7xl'>
              Hello 👋🏽 ! I'm Ale.
            </div>
            <div className='text-xs xl:text-3xl 2xl:text-4xl dark:text-stone-200'>
              I graduated from the <span className='font-bold dark:text-white'>University of Bologna</span>, with a Bachelor's degree in <span className='font-bold dark:text-white'>Computer Engineering</span>.
              My passion for technology then inspired me to pursue a Master's degree in <span className='font-bold dark:text-white'>Artificial Intelligence</span>.
            </div>

            <div className='flex gap-2 xl:gap-4 2xl:gap-10'>
              <SocialButton name='LinkedIn' color='bg-[#0077B5]' link="https://www.linkedin.com/in/alepower"/>
              <SocialButton name='GitHub' color='bg-[#24292e]'link="https://github.com/notalepower" />
            </div>

        </div>
        
        {/* PHOTO */}
        <div className='w-1/2 flex flex-col justify-center items-center p-2 2xl:p-10'>
          <div className='bg-opache sm:w-5/6'>
            <img src={photo} className='rounded-full min-w-full aspect-square object-cover' alt='Foto Profilo'/>
          </div>
        </div>

    </div>
  )
}
